import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoalibaugcab() {



    const cardData = {

keyword: "Pune to Alibag Cab",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Alibag Cab services for families, couples, and weekend travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth coastal highway journey from Pune to Alibag. Our service includes doorstep pickup, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a relaxing and enjoyable travel experience to the beaches and forts of Alibag.",

topPlaces: [
    {
        title: "Alibag Beach",
        description:
            "Alibag Beach is the main attraction of the town, known for its black sand shoreline, calm sea waves, and beautiful sunset views. It is a popular spot for evening walks, photography, and relaxing coastal experiences away from city life."
    },
    {
        title: "Kolaba Fort",
        description:
            "Kolaba Fort is a historic sea fort located just off Alibag Beach and can be reached during low tide by walking through the sea or by boat. Built during the Maratha era, it offers ancient architecture, cannons, and scenic Arabian Sea views."
    },
    {
        title: "Nagaon Beach",
        description:
            "Nagaon Beach is one of the cleanest and most popular beaches near Alibag, known for water sports like banana rides, jet skiing, and parasailing. The long sandy stretch and palm trees make it ideal for family outings and beach activities."
    },
    {
        title: "Kashid Beach",
        description:
            "Kashid Beach is famous for its white sand, turquoise water, and peaceful surroundings. Located a short drive from Alibag, it is perfect for relaxation, photography, and long scenic walks along the shoreline."
    },
    {
        title: "Murud-Janjira Fort",
        description:
            "Murud-Janjira Fort is one of the strongest sea forts in India, located on an island near the coastal town of Murud. Accessible only by boat, it offers stunning sea views and rich Maratha-era history."
    },
    {
        title: "Kihim Beach",
        description:
            "Kihim Beach is a quiet and scenic beach known for its clean surroundings, butterfly sightings, and peaceful atmosphere. It is ideal for travelers looking for a less crowded coastal experience near Alibag."
    },
    {
        title: "Varsoli Beach",
        description:
            "Varsoli Beach is a calm and less commercialized beach near Alibag, popular for relaxing walks, water sports, and peaceful sunsets. It is often preferred by families seeking a quiet beach experience."
    },
    {
        title: "Revdanda Fort",
        description:
            "Revdanda Fort is a historical Portuguese-era fort located near Alibag, surrounded by coconut trees and coastal scenery. Though partially in ruins, it offers a glimpse of history along with beautiful sea views."
    },
    {
        title: "Mandwa Jetty",
        description:
            "Mandwa Jetty is a major coastal point near Alibag connecting ferry services to Mumbai. It is a busy yet scenic location offering sea views and quick access to nearby beaches and resorts."
    },
    {
        title: "Alibag Coastal Villages",
        description:
            "The villages around Alibag showcase traditional Konkan lifestyle, coconut farms, and peaceful rural surroundings. These areas provide an authentic coastal experience along the Pune to Alibag route."
    }
],



services: [
  {
    name: "Pune to Alibag Cab",
    description: "Rising Cab Service offers reliable Pune to Alibag Cab service for a comfortable and scenic coastal journey to Alibag beach town. Our service is ideal for families, couples, and groups planning weekend getaways, beach holidays, or corporate trips. We provide well-maintained AC vehicles, experienced long-route drivers, doorstep pickup from Pune, flexible scheduling, and 24x7 support. Enjoy a smooth highway drive followed by a relaxing coastal experience with transparent pricing and complete travel comfort."
  },
  {
    name: "Pune to Alibag Taxi",
    description: "Book Pune to Alibag Taxi with Rising Cab Service for a safe, affordable, and stress-free journey to the popular beach destination of Alibag. We offer clean and sanitized vehicles, professional chauffeurs, and flexible pickup and drop options. Whether it’s a weekend trip or a long holiday, our taxis ensure smooth driving, timely service, and comfortable travel across highways and ferry-connected routes if required."
  },
  {
    name: "Cab from Pune to Alibag",
    description: "Hire Cab from Pune to Alibag for convenient door-to-door travel with complete comfort and flexibility. Choose from sedans, SUVs, and Innova Crysta based on your group size and budget. Our experienced drivers ensure safe navigation through highways and coastal routes, making your journey relaxing and enjoyable with planned stops and travel assistance."
  },
  {
    name: "Taxi from Pune to Alibag",
    description: "Taxi from Pune to Alibag service by Rising Cab Service ensures punctual pickup, professional driving, and a smooth travel experience. Perfect for beach vacations, family outings, and weekend trips, our taxis offer AC comfort, affordable pricing, and reliable long-distance travel support."
  },
  {
    name: "Pune to Alibag Cab Service",
    description: "Our Pune to Alibag Cab Service provides complete travel solutions including pickup, drop, sightseeing flexibility, and return options. We focus on safety, comfort, and affordability with trained drivers, well-maintained vehicles, and 24x7 booking assistance for a hassle-free coastal trip."
  },
  {
    name: "Pune to Alibag Taxi Fare",
    description: "Get transparent Pune to Alibag Taxi Fare with clear and affordable pricing based on vehicle type and travel plan. We offer budget-friendly and premium options for sedans, SUVs, and luxury vehicles with no hidden charges, ensuring value for money and a comfortable travel experience."
  },
  {
    name: "Pune to Alibag One Way Cab",
    description: "Book Pune to Alibag One Way Cab for economical drop-only travel to the coastal city of Alibag. Ideal for solo travelers and families, this service includes AC vehicles, professional drivers, and smooth highway travel at affordable rates without return charges."
  },
  {
    name: "Pune to Alibag Round Trip Taxi",
    description: "Pune to Alibag Round Trip Taxi service is perfect for weekend getaways and beach holidays. It includes waiting time, flexible return scheduling, comfortable vehicles, and experienced drivers for a complete and stress-free round trip experience."
  },
  {
    name: "Pune to Alibag Cab Booking",
    description: "Easy Pune to Alibag Cab Booking system for instant reservations with multiple vehicle choices including Sedan, SUV, and Innova Crysta. Get quick confirmation, transparent pricing, and 24x7 customer support for a smooth travel experience."
  },
  {
    name: "Cheap Pune to Alibag Cab",
    description: "Affordable Cheap Pune to Alibag Cab service for budget travelers who want economical yet safe coastal travel. We provide low-cost fares, clean vehicles, and professional drivers without compromising comfort or safety."
  },
  {
    name: "Best Pune to Alibag Taxi",
    description: "Choose Best Pune to Alibag Taxi service for premium travel experience with top-rated drivers, comfortable vehicles, and smooth highway driving. We ensure punctuality, safety, and complete customer satisfaction for your beach trip."
  },
  {
    name: "Sedan Pune to Alibag Cab",
    description: "Sedan Pune to Alibag Cab service is ideal for solo travelers, couples, and small families looking for comfortable and budget-friendly travel. Enjoy fuel-efficient cars, smooth rides, and professional drivers for a safe journey."
  },
  {
    name: "SUV Pune to Alibag Taxi",
    description: "Book SUV Pune to Alibag Taxi for group travel requiring extra space and comfort. Our SUVs offer strong road performance, spacious interiors, and smooth rides for long highway and coastal journeys."
  },
  {
    name: "Innova Pune to Alibag Cab",
    description: "Premium Innova Pune to Alibag Cab service designed for families and groups seeking extra comfort and luxury. Enjoy spacious seating, smooth suspension, and experienced chauffeurs for a relaxing beach trip."
  },
  {
    name: "Beach Cab Pune Alibag",
    description: "Beach Cab Pune Alibag service is specially designed for tourists visiting Alibag beaches. Enjoy scenic coastal routes, flexible stops, and comfortable AC vehicles for a perfect holiday experience."
  },
  {
    name: "Pune to Alibag Outstation Cab",
    description: "Reliable Pune to Alibag Outstation Cab service for safe intercity travel with professional drivers, flexible booking options, and well-maintained vehicles suitable for all types of travelers."
  },
  {
    name: "Pune to Alibag Tour Package",
    description: "Complete Pune to Alibag Tour Package including pickup, beach visits, sightseeing, and return journey for a hassle-free coastal vacation experience."
  },
  {
    name: "Alibag Cab from Pune",
    description: "Alibag Cab from Pune service offers direct and comfortable travel to the beach destination with door-to-door pickup, safe driving, and flexible travel plans."
  },
  {
    name: "Pune to Alibag Beach Tour Cab",
    description: "Pune to Alibag Beach Tour Cab service ensures a scenic and relaxing journey to Alibag beaches with professional drivers and comfortable vehicles."
  },
  {
    name: "Pune to Alibag Holiday Package Cab",
    description: "Pune to Alibag Holiday Package Cab offers complete travel solutions for weekend and holiday trips with sightseeing, beach visits, and return journey included."
  },
  {
    name: "Pune to Alibag Luxury Cab Service",
    description: "Premium Pune to Alibag Luxury Cab Service offering high-end vehicles, professional chauffeurs, and enhanced comfort for a superior travel experience."
  },
  {
    name: "Pune to Alibag Tourist Taxi",
    description: "Pune to Alibag Tourist Taxi service provides reliable travel for tourists exploring Alibag beaches and nearby attractions with flexible and safe transportation."
  },
  {
    name: "Pune to Alibag Weekend Trip Cab",
    description: "Pune to Alibag Weekend Trip Cab service is perfect for short weekend getaways with family and friends, offering comfortable rides and flexible return options."
  }
],

tableData: [
  ["Pune to Alibag Cab", "Pune to Alibag Taxi"],
  ["Cab from Pune to Alibag", "Taxi from Pune to Alibag"],
  ["Pune to Alibag Cab Service", "Pune to Alibag Taxi Fare"],
  ["Pune to Alibag One Way Cab", "Pune to Alibag Round Trip Taxi"],
  ["Pune to Alibag Cab Booking", "Cheap Pune to Alibag Cab"],
  ["Best Pune to Alibag Taxi", "Sedan Pune to Alibag Cab"],
  ["SUV Pune to Alibag Taxi", "Innova Pune to Alibag Cab"],
  ["Beach Cab Pune Alibag", "Alibag Cab from Pune"],
  ["Pune to Alibag Tour Package", "Pune to Alibag Holiday Package Cab"],
  ["Pune to Alibag Outstation Cab", "Pune to Alibag Luxury Cab Service"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Alibag Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Alibag cab transportation for families, tourists, couples, corporate travelers, and beach holiday enthusiasts."
    },
    {
        WhyChooseheading: "Perfect for Beach Vacations and Weekend Getaways",
        WhyChoosedescription: "Alibag is one of Maharashtra's most popular coastal destinations, attracting visitors with beautiful beaches, sea views, forts, and relaxing holiday experiences."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Packages",
        WhyChoosedescription: "Customers can choose one-way transfers, same-day return journeys, weekend tours, overnight stays, and customized Alibag travel packages."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Journey",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for individuals, families, and groups."
    },
    {
        WhyChooseheading: "Explore Popular Attractions in Alibag",
        WhyChoosedescription: "Travel conveniently to Alibag Beach, Kolaba Fort, Nagaon Beach, Kihim Beach, Varsoli Beach, Murud-Janjira Fort, and other famous attractions."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Safe Coastal Route Travel",
        WhyChoosedescription: "Our experienced drivers ensure smooth and secure travel, allowing passengers to enjoy the scenic Konkan route comfortably."
    },
    {
        WhyChooseheading: "Ideal for Family Trips and Group Tours",
        WhyChoosedescription: "Rising Cab Service caters to family vacations, honeymoon trips, corporate outings, beach holidays, and sightseeing tours."
    }
]
};

const faqData = [
    {
        question: "Why is Alibag a popular tourist destination from Pune?",
        answer: "Alibag is famous for its beaches, water sports, coastal beauty, historic forts, seafood cuisine, and relaxing holiday atmosphere."
    },
    {
        question: "Can I book a one-way cab from Pune to Alibag?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which attractions can be visited during an Alibag trip?",
        answer: "Popular attractions include Alibag Beach, Kolaba Fort, Nagaon Beach, Kihim Beach, Varsoli Beach, Murud-Janjira Fort, and Revdanda Beach."
    },
    {
        question: "Which vehicle is suitable for a family trip to Alibag?",
        answer: "Ertiga and Innova Crysta are popular choices because they offer comfortable seating and sufficient luggage space."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family groups, corporate outings, and tourist groups."
    },
    {
        question: "Can same-day return trips be arranged from Pune?",
        answer: "Yes, same-day return cab packages are available depending on the customer's travel schedule."
    },
    {
        question: "Are beach sightseeing and fort visits included in the trip?",
        answer: "Yes, customers can customize their itinerary to include beaches, forts, water sports locations, and nearby attractions."
    },
    {
        question: "Can Alibag be combined with other Konkan destinations?",
        answer: "Yes, customized packages can include Murud, Kashid, Harihareshwar, Shrivardhan, and other coastal destinations."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Alibag Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akshay Patil",
        feedback:
            "Our weekend trip to Alibag was fantastic. The vehicle was comfortable, the journey was smooth, and we enjoyed every beach destination without worrying about transportation.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priti Kulkarni",
        feedback:
            "The family vacation to Alibag became truly memorable thanks to the excellent travel arrangements. The cab was clean, spacious, and perfect for our coastal getaway.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Alibag Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-alibag-cab.jpg",
"description": "Book Pune to Alibag Cab Service with Rising Cab Service for safe and comfortable beach travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family trips and weekend getaways.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-alibag-cab"
}
};






    return (
        <div>
<Helmet>
  <title>Pune to Alibag Cab Service | Beach Taxi Booking | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Alibag Cab Service for safe and comfortable beach travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for Alibag trips."
/>

<meta
 name="keywords"
 content="pune to alibag cab, pune to alibag taxi, cab from pune to alibag, taxi from pune to alibag, pune to alibag cab service, pune to alibag taxi fare, pune to alibag one way cab, pune to alibag round trip taxi, pune to alibag cab booking, cheap pune to alibag cab, best pune to alibag taxi, sedan pune to alibag cab, suv pune to alibag taxi, innova pune to alibag cab, beach cab pune alibag, Pune to Alibag Cab, Pune to Alibag Taxi Service, Pune to Alibag Cab Booking, Pune to Alibag One Way Cab, Pune to Alibag Round Trip Cab, Pune to Alibag Taxi Booking"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoalibaugcab;